import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { BsGithub } from "react-icons/bs";
import { MdFiberManualRecord } from "react-icons/md";

const ProjectDetails = (props) => {
  const params = useParams();
  const project = props.projects.filter(
    (project) => project.params === params.id
  )[0];
  return (
    <Container>
      <section id="project-details" className="pt-5 px-5">
        <h3 className="mb-5 text-center">{project.title.toUpperCase()}</h3>
        <Row>
          <Col lg={6}>
            <div className="img-wrapper">
              <img
                src={project.img}
                alt={project.title}
                width="100%"
                height="250px"
              />
            </div>
          </Col>
          <Col lg={6}>
            <p>Title: {project.title}</p>
            <p>Description: {project.description}</p>
            <p>Languages: {project.languages}</p>
            <div className="mb-3">
              <a href={project.github} target="_blank" rel="noreferrer">
                <button className="mb-3">
                  GitHub <BsGithub />{" "}
                </button>
              </a>
            </div>
            <div>
              <a href={project.demo} target="_blank" rel="noreferrer">
                <button className="mb-3">
                  Go Live <MdFiberManualRecord style={{ color: "red" }} />{" "}
                </button>
              </a>
            </div>
            <Link to="/portfolio/">
              <u style={{ color: "black" }}>Back to Portfolio</u>
            </Link>
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default ProjectDetails;
